import { Constants } from "../utils/constants";
import axios from "axios";
import { api } from "./api";

export const generateLocalToken = async () => {
  const token = await axios
    .post(
      Constants.URL.base + Constants.URL.auth,
      {
        client_secret: Constants.client.secret,
        client_id: Constants.client.id,
        grant_type: "client_credentials",
      },
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((data) => data?.data)
    .catch((error) => {
      console.log(error);
    });

  console.log("myToken", token);
  return token;
};

export const attachPauth = (apiUrl) => {
  let token = window?.Liferay?.authToken;
  console.log("apiutrl", apiUrl);
  return (
    apiUrl +
    (apiUrl?.split("").includes("?") ? `&p_auth=${token}` : `?p_auth=${token}`)
  );
};

// Function to login user with email
export const loginUser = async (email) => {
  const url = `${Constants.URL.login}?emailAddress=${email}`;

  try {
    const response = await api.get(url);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return null;
  }
};

export const verifyUser = async (email, otp) => {
  const url = Constants.URL.verify;
  const data = await api
    .post(
      url,
      {
        otp: otp,
        emailId: email,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    )
    .then((data) => data?.data)
    .catch((error) => {
      console.log(error);
    });
  return data;
};

export const verifyResetOtp = async (otp, email) => {
  const url = Constants.URL.verifyResetOtp
  const data = await api
  .post(
    url,
    {
      otp: otp,
      emailId: email,
    },
    {
      headers: {
        "content-type": "application/json",
      },
    }
  )
  .then((data) => data?.data)
  .catch((error) => {
    console.log(error);
  });
return data;
};
export const resetPassword = async (emailId, newPassword) =>{
  return api.post(
    Constants.URL.resetPassword,
    JSON.stringify({
      emailId,
      newPassword
     }),
    {
      headers: {
        'content-type': 'application/json'
      }
    }
  )
};

export const changePassword = (oldPassword,newPassword) => {
  return api.post(
    Constants.URL.changePassword,
    JSON.stringify({
      oldPassword,
      newPassword
     }),
    {
      headers: {
        'content-type': 'application/json'
      }
    }
  )
}
